import { render, staticRenderFns } from "./SystemIndex.vue?vue&type=template&id=cddc49ee&scoped=true"
import script from "./SystemIndex.vue?vue&type=script&lang=js"
export * from "./SystemIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddc49ee",
  null
  
)

export default component.exports